import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const CurrentProbation = React.lazy(() => import ("@/pages/probation/currentProbation.jsx"));
const ExtendedProbation = React.lazy(() => import ("@/pages/probation/extendedProbation.jsx"));
const ConfirmedProbation = React.lazy(() => import ("@/pages/probation/confirmedProbation.jsx"));
const FeedbackForm = React.lazy(() => import ("@/pages/probation/feedbackForm.jsx"));
const GetFeedbackForm = React.lazy(() => import ("@/pages/probation/getFeedbackForm.jsx"));
const EditFeedbackForm = React.lazy(() => import ("@/pages/probation/editFeedbackForm.jsx"));
const SubmitFeedbackForm = React.lazy(() => import ("@/pages/probation/submitFeedbackForm.jsx"));
const IndexTab = React.lazy(() => import ("@/pages/probation/indexTab.jsx"));
const IndexTabTrainee = React.lazy(() => import ("@/pages/probation/indexTabTrainee"));
const Index = React.lazy(() => import ("@/pages/probation/index.jsx"));
const IndexProbations = [
    {
        path: "currentProbationList",
        element: (
            <SuspenseWrapper>
                <CurrentProbation />    
            </SuspenseWrapper>
        ),
    },
    {
        path: "traineeProbationList",
        element: (
            <SuspenseWrapper>
                <IndexTabTrainee />    
            </SuspenseWrapper>
        ),
    },
    {
        path: "ProbationList",
        element: (
            <SuspenseWrapper>
                <IndexTab />    
            </SuspenseWrapper>
        ),
    },
    {
        path: "extendedProbationList",
        element: (
            <SuspenseWrapper>
                <ExtendedProbation />
            </SuspenseWrapper>
        ),
    },
    {
        path: "confirmedProbationList",
        element: (
            <SuspenseWrapper>
                <ConfirmedProbation />
            </SuspenseWrapper>
        ),
    },
    // {
    //     path: "probation",
    //     element: (
    //         <SuspenseWrapper>
    //             <Index />
    //         </SuspenseWrapper>
    //     ),
    // },
    {
        path: "feedbackForm",
        element: (
            <SuspenseWrapper>
                <FeedbackForm />
            </SuspenseWrapper>
        ),
    },
    {
        path: "getFeedbackForm",
        element: (
            <SuspenseWrapper>
                <GetFeedbackForm />
            </SuspenseWrapper> 
        ),
    },
    {
        path: "editFeedbackForm",
        element: (
            <SuspenseWrapper>
                <EditFeedbackForm />
            </SuspenseWrapper>
        ),
    },
    {
        path: "submitFeedbackForm",
        element: (
            <SuspenseWrapper>
                <SubmitFeedbackForm />
            </SuspenseWrapper>
        ),
    }
];
export default IndexProbations; 